import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "title-color-black my-5" }, "IRB Chair", -1)
const _hoisted_2 = { class: "mb-5 mb-xl-8 card" }
const _hoisted_3 = { class: "card-body py-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "title-color-brown" }, "Expedited Unassigned Applications", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 subtitle-color-gray" }, " Expedited Unassigned IRB Applications ", -1)
const _hoisted_6 = { class: "table-responsive" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AplicationTableAction = _resolveComponent("AplicationTableAction")!
  const _component_KtAssignIrbModal = _resolveComponent("KtAssignIrbModal")!
  const _component_KtMemberApprovalModal = _resolveComponent("KtMemberApprovalModal")!
  const _component_KtTransactionModal = _resolveComponent("KtTransactionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_AplicationTableAction, {
            hiddeSearchBar: false,
            hideRadio: true,
            list: _ctx.currentIrbchairApps?.data,
            functionToCall: _ctx.viewDetail,
            pagination: _ctx.currentIrbchairApps?.filters,
            tableColumns: _ctx.tableColumns,
            tableCallFunction: _ctx.tableCallFunction
          }, null, 8, ["list", "functionToCall", "pagination", "tableColumns", "tableCallFunction"])
        ])
      ])
    ]),
    _createVNode(_component_KtAssignIrbModal),
    _createVNode(_component_KtMemberApprovalModal),
    _createVNode(_component_KtTransactionModal)
  ], 64))
}